'use client';
import React from 'react';
import cn from './style.module.scss';
import {useParams} from 'next/navigation';

interface SuccessMessageProps {
  t: {[key: string]: string};
  successPopUpLink: string;
  ContentClassName?: string;
  ButtonClassName?: string;
}
export default function SuccessMessage({
  t,
  successPopUpLink,
  ContentClassName = '',
  ButtonClassName = '',
}: SuccessMessageProps) {
  const {lang} = useParams();

  return (
    <div className={cn.registerSuccessWrapper}>
      <div data-notranslate className={cn.registerSuccessMessage}>
        <div className={cn.registerSuccessInner}>
          <div className={`${cn.registerSuccessContent} ${ContentClassName}`}>
            <h2>{t['successHeading']}</h2>
            <p>{t['successContent']}</p>
          </div>
          <div className={cn.registerSuccessButton}>
            <a
              href={successPopUpLink}
              target='_blank'
              className={`${cn.successButtonElement} ${ButtonClassName}`}>
              <span>{t['successButton']}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
